// src/components/VadesiYaklasanlar.js

import React, { useState, useEffect } from 'react'; // Hata burada düzeltildi
import { db } from '../../firebase';
import { collection, query, where, orderBy, onSnapshot, getDocs } from 'firebase/firestore';
import { Paper, Typography, Divider, Stack, CircularProgress, Box, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { startOfDay } from 'date-fns';

const VadesiYaklasanlar = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUpcoming = async () => {
            setLoading(true);
            try {
                const today = new Date();

                // Start date: 30 days ago
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - 30);
                thirtyDaysAgo.setHours(0, 0, 0, 0);

                // End date: 30 days from now
                const nextThirtyDays = new Date();
                nextThirtyDays.setDate(today.getDate() + 30);
                nextThirtyDays.setHours(23, 59, 59, 999);

                // 1. Planlanmış Ödemeler (Genişletilmiş Aralık)
                let plannedPayments = [];
                try {
                    const paymentsQuery = query(
                        collection(db, "scheduledPayments"),
                        where("durum", "==", "Bekleniyor"),
                        where("vadeTarihi", ">=", thirtyDaysAgo),
                        where("vadeTarihi", "<=", nextThirtyDays),
                        orderBy("vadeTarihi", "asc")
                    );
                    const paymentsSnap = await getDocs(paymentsQuery);
                    plannedPayments = paymentsSnap.docs.map(doc => ({
                        id: doc.id,
                        type: 'planned',
                        ...doc.data(),
                        date: doc.data().vadeTarihi
                    }));
                } catch (err) {
                    console.error("Planlanmış ödemeler çekilemedi (Index hatası olabilir):", err);
                }

                // 2. Teslim Tarihi Yaklaşan ve Borcu Olan Servisler
                let serviceDebts = [];
                try {
                    const servicesQuery = query(
                        collection(db, "serviceRecords"),
                        where("kalanTutar", ">", 0),
                        where("teslimTarihi", ">=", thirtyDaysAgo),
                        where("teslimTarihi", "<=", nextThirtyDays),
                        orderBy("teslimTarihi", "asc")
                    );
                    const servicesSnap = await getDocs(servicesQuery);
                    serviceDebts = servicesSnap.docs.map(doc => ({
                        id: doc.id,
                        type: 'service',
                        musteriId: doc.data().musteriId,
                        musteriAdSoyad: doc.data().musteriAdSoyad,
                        tutar: doc.data().kalanTutar,
                        aciklama: `Servis Teslim: #${doc.data().serviceNo || doc.data().cihazSeriNumarasi}`,
                        date: doc.data().teslimTarihi, // Vade tarihi olarak teslim tarihini alıyoruz
                        ...doc.data()
                    }));
                } catch (err) {
                    console.error("Servis borçları çekilemedi:", err);
                }

                const combined = [...plannedPayments, ...serviceDebts];
                combined.sort((a, b) => (a.date?.toMillis() || 0) - (b.date?.toMillis() || 0));

                setPayments(combined);

            } catch (error) {
                console.error("Vadesi yaklaşanlar çekilirken hata:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUpcoming();
    }, []);

    return (
        <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h6" gutterBottom>Vadesi Yaklaşanlar ({payments.length})</Typography>
            <Divider />
            {loading ? <CircularProgress sx={{ m: 'auto' }} /> : (
                <Stack spacing={1.5} sx={{ mt: 2, flexGrow: 1, overflowY: 'auto', pr: 1, maxHeight: '300px' }}>
                    {payments.length > 0 ? payments.map(p => (
                        <MuiLink component={RouterLink} to={p.type === 'service' ? `/servis-kaydi/${p.id}` : `/musteri/${p.musteriId}`} key={`${p.type}-${p.id}`} sx={{ textDecoration: 'none' }}>
                            <Paper variant="outlined" sx={{ p: 1.5, '&:hover': { backgroundColor: 'action.hover' } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" fontWeight="bold">{p.musteriAdSoyad}</Typography>
                                    <Typography variant="body2" color="error.main" fontWeight="bold">
                                        {(p.tutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                                    </Typography>
                                </Box>
                                <Typography variant="caption" color="text.secondary">
                                    Vade: {p.date?.toDate().toLocaleDateString('tr-TR')}
                                </Typography>
                            </Paper>
                        </MuiLink>
                    )) : (
                        <Typography color="text.secondary" sx={{ textAlign: 'center', pt: 2 }}>
                            Yakın tarihli planlanmış ödeme yok.
                        </Typography>
                    )}
                </Stack>
            )}
        </Paper>
    );
};

export default VadesiYaklasanlar;